import { Navigate } from "react-router-dom"
import Cookies from "js-cookie"

const ProtectedRoute = ({ children }) => {

  const loginData = JSON.parse(
    Cookies.get("logincrd") || "{}"
  )

  if (!loginData?.token) {
    return <Navigate to="/login" replace />
  }

  return children
}

export default ProtectedRoute